import type { ChangeEvent } from "react";

export interface LanguageSelectOption {
  value: string;
  label: string;
}

interface LanguageSelectProps {
  id: string;
  value: string;
  options: LanguageSelectOption[];
  disabled?: boolean;
  ariaLabel?: string;
  onChange: (value: string) => void;
}

export function LanguageSelect({
  id,
  value,
  options,
  disabled,
  ariaLabel,
  onChange
}: LanguageSelectProps) {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <select
      id={id}
      className="block w-full rounded-xl border-0 py-2.5 text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 disabled:bg-slate-50 disabled:text-slate-500 disabled:ring-slate-200 dark:bg-slate-900 dark:text-slate-100 dark:ring-slate-700 dark:disabled:bg-slate-800"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
